<div class="margin-top mt16 mb-32 acmic-coverages">
    <ng-container *ngFor="let vehicle of policy?.vehicle | sort: 'vehicleNumber' : 'asc';
                            let index = index;">
        <div>
            <ng-container *ngIf="checkForSingleVehicle(policy?.vehicle); else collapseView">
                <div class="row vehicle-title mb26">
                    <div class="col c-v-gray-title margin-top mt16">{{ vehicle.vehicle | lowercase }}</div>
                </div>
            </ng-container>
            <ng-template #collapseView>
                <a [id]="'title'+index" class="mapfre link collapse-link"
                    (click)="toggleCollapse(vehicle.coverages,index)" mdbRipple>

                    <div class="row vehicle-title">
                        <div class="col c-v-title">{{ vehicle.vehicle | lowercase }}</div>
                        <div class="col collapse-carot text-right">
                            <div class="arrow-down">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M16.5749 9.975C16.2749 9.675 15.8249 9.675 15.5249 9.975L11.9999 13.425L8.5499 9.975C8.2499 9.675 7.7999 9.675 7.4999 9.975C7.1999 10.275 7.1999 10.725 7.4999 11.025L11.4749 15C11.6249 15.15 11.7749 15.225 11.9999 15.225C12.2249 15.225 12.3749 15.15 12.5249 15L16.5749 11.025C16.8749 10.725 16.8749 10.275 16.5749 9.975Z" fill="#005095"/>
                                </svg>
                            </div>
                            <div class="arrow-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M16.5 12.9749L12.525 8.9999C12.225 8.6999 11.775 8.6999 11.475 8.9999L7.42495 12.9749C7.12495 13.2749 7.12495 13.7249 7.42495 14.0249C7.57495 14.1749 7.72495 14.2499 7.94995 14.2499C8.17495 14.2499 8.32495 14.1749 8.47495 14.0249L12 10.5749L15.45 14.0249C15.75 14.3249 16.2 14.3249 16.5 14.0249C16.8 13.7249 16.8 13.2749 16.5 12.9749Z" fill="#005095"/>
                                    </svg>
                                </div>
                        </div>
                    </div>
                </a>
            </ng-template>
            <div [id]="'collapse'+index" class="row collapse-content"
                [ngClass]="{ 'show': policy?.vehicle.length === 1 }">
                <div class="w-100">
                    <div class="container loggedin">
                        <div class="row coverage-title">
                            <div class="col-md-6 col-sm-12">

                            </div>
                            <div class="col-md-3 c-width c-text-align c-text-left c-mrgtop mobile-text">
                                Limits
                            </div>
                            <div class="col-md-3 c-width c-text-align c-mrgtop mobile-text">
                                Deductible
                            </div>
                        </div>

                        <div class="row fs-14" *ngFor="let vehicleCoverage of vehicle.coverages" [ngClass]="{ 'mb-4 mt-4': (vehicleCoverage?.coverageName?.includes('UnderInsured Motorist') 
                        && vehicleCoverage?.coverageName !== 'UnderInsured Motorist Property Damage')
                        || vehicleCoverage?.coverageName?.includes('Personal Injury Protection')
                        || vehicleCoverage?.coverageName?.includes('Extended Non Owned')
                        || vehicleCoverage?.coverageName?.includes('Uninsured Motorist') }">

                            <ng-container
                                *ngIf="(vehicleCoverage?.coverageName?.includes('UnderInsured Motorist') 
                                && vehicleCoverage?.coverageName !== 'UnderInsured Motorist Property Damage')
                                || vehicleCoverage?.coverageName?.includes('Uninsured Motorist'); else personalINjuryCoverage">
                                <div class="col-md-12 col-sm-12 c-padding-l f-w-700 bold-left-text">
                                    {{ getMotoristCoverageName(vehicleCoverage?.coverageName) }}
                                </div>
                                <div class="row fs-14 w-100 no-margin-horizontal"
                                        *ngFor="let subCoverage of vehicleCoverage.subCoverages">
                                        <div class="col-md-6 col-sm-12 c-padding-l left-text">
                                                {{subCoverage.coverageName}}
                                        </div>
                                        <div class="col-md-3 c-width c-text c-text-align c-text-left">
                                            <ng-container *ngIf="subCoverage.coverageLimit === 'Rejected'; else notRejectedSubLimit">
                                                Rejected
                                            </ng-container>
                                            <ng-template #notRejectedSubLimit>
                                                <ng-container *ngIf="subCoverage.coverageLimit;else noSubCoverageLimit">
                                                    {{ subCoverage.coverageLimit | customCurrency }}
                                                </ng-container>
                                                <ng-template #noSubCoverageLimit>
                                                    <ng-container
                                                        *ngIf="vehicleCoverage?.coverageName?.includes('Uninsured Motorist'); else noSubCoverageLimitForUnderInsured">
                                                        Rejected
                                                    </ng-container>
                                                    <ng-template #noSubCoverageLimitForUnderInsured>
                                                        N/A
                                                    </ng-template>
                                                </ng-template>
                                            </ng-template>                                        
                                        </div>
                                        <div class="col-md-3 c-width c-text c-text-align">
                                            N/A
                                        </div>
                                </div>
                            </ng-container>
                            <!-- personal injury, Extended Non Owned -->
                            <ng-template #personalINjuryCoverage>
                                <ng-container *ngIf="vehicleCoverage?.coverageName?.includes('Personal Injury Protection') || 
                                vehicleCoverage?.coverageName?.includes('Extended Non Owned'); else otherCoverage">
                                    <div class="col-md-12 col-sm-12 c-padding-l f-w-700 bold-left-text">
                                        {{ vehicleCoverage?.coverageName }}
                                    </div>
                                    <div class="row fs-14 w-100 no-margin-horizontal"
                                        *ngFor="let personalInjuryTerm  of vehicleCoverage.coverageTerms">
                                        <ng-container *ngIf="personalInjuryTerm.termModelType === 'Limit' ||
                                                            personalInjuryTerm.termModelType === 'Deductible'">
                                            <div class="col-md-6 col-sm-12 c-padding-l left-text">
                                                {{ personalInjuryTerm?.termName }}
                                            </div>
                                            <div class="col-md-3 c-width c-text c-text-align c-text-left">
                                                <ng-container
                                                    *ngIf="isItHavePersonalTermAmout(personalInjuryTerm, 'Limit');else pLimitNotApplicable">
                                                    {{ personalInjuryTermAmout | customCurrency }}
                                                </ng-container>
                                                <ng-template #pLimitNotApplicable>
                                                    N/A
                                                </ng-template>
                                            </div>
                                            <div class="col-md-3 c-width c-text c-text-align">
                                                <ng-container
                                                    *ngIf="isItHavePersonalTermAmout(personalInjuryTerm, 'Deductible'); else pDeductNotApplicable">

                                                    {{ personalInjuryTermAmout | customCurrency }}
                                                </ng-container>
                                                <ng-template #pDeductNotApplicable>
                                                    N/A
                                                </ng-template>
                                            </div>
                                        </ng-container>
                                    </div>

                                </ng-container>
                                <ng-template #otherCoverage>
                                    <div class="col-md-6 col-sm-12 c-padding-l left-text">
                                        {{ vehicleCoverage.coverageName }}
                                    </div>
                                </ng-template>
                            </ng-template>
                            <ng-container *ngIf="!vehicleCoverage?.coverageName?.includes('Personal Injury Protection') && 
                            !vehicleCoverage?.coverageName?.includes('Extended Non Owned') && 
                            !(vehicleCoverage?.coverageName?.includes('UnderInsured Motorist')) && 
                            !vehicleCoverage?.coverageName?.includes('Uninsured Motorist')">
                                <div class="col-md-3 c-width c-text c-text-align c-text-left">
                                    <ng-container *ngIf="vehicleCoverage?.coverageName?.includes('AutoMaster Elite') ||
                                    vehicleCoverage?.coverageName?.includes('Peace of Mind (Deductible Credit)') ||
                                    vehicleCoverage?.coverageName?.includes('AAA Member Package'); else limitValueNotInlcuded">
                                        Included
                                    </ng-container>
                                    <ng-template #limitValueNotInlcuded>
                                        <ng-container *ngIf="vehicleCoverage?.coverageLimit ==='Rejected'; else notRejected">
                                            Rejected
                                        </ng-container>
                                        <ng-template #notRejected>
                                            <ng-container *ngIf="vehicleCoverage?.coverageLimit;else limitNotApplicable">
                                                <ng-container *ngIf="vehicleCoverage.coverageName === 'Rental Reimbursement (Per Day/Accident)'; else notRental">
                                                    {{ vehicleCoverage?.coverageTerms[0]?.termAmount | customCurrency:vehicleCoverage.coverageName }}
                                                </ng-container>
                                                <ng-template #notRental>
                                                    {{ vehicleCoverage?.coverageLimit | customCurrency }}
                                                </ng-template>
                                            </ng-container>
                                            <ng-template #limitNotApplicable>
                                                <ng-container
                                                    *ngIf="vehicleCoverage.coverageName === 'Collision Loss Settlement' 
                                                                                                    || vehicleCoverage.coverageName === 'Other Than Collision Loss Settle'; else notCollision">
                                                    <ng-container *ngFor="let collisionTerm of vehicleCoverage.coverageTerms">
                                                        <ng-container *ngIf="collisionTerm.termAmount === 'Actual Cash Value'">
                                                            ACV
                                                        </ng-container>
                                                        <ng-container *ngIf="collisionTerm.termAmount === 'Total Loss Replacement/Purchase Price'">
                                                            REPACV
                                                        </ng-container>
                                                        <ng-container *ngIf="collisionTerm.termAmount === 'Stated Amount'">
                                                            Stated
                                                        </ng-container>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-template #notCollision>
                                                    N/A
                                                </ng-template>
                                            </ng-template>
                                        </ng-template>
                                    
                                    </ng-template>
                                    
                                </div>
                                <div class="col-md-3 c-width c-text c-text-align">
                                    <ng-container
                                        *ngIf="isItHaveDeductible(vehicleCoverage.coverageTerms, 'Deductible', vehicleCoverage.coverageName);else deductNotApplicable">
                                        <ng-container
                                            *ngIf="vehicleCoverage?.coverageName?.includes('Peace of Mind (Deductible Credit)'); else otherDeductible">
                                            ({{ deductibleTerm?.termAmount | customCurrency }})
                                        </ng-container>
                                        <ng-template #otherDeductible>
                                            {{ deductibleTerm?.termAmount | customCurrency }}
                                        </ng-template>
                                    </ng-container>                                    
                                    <ng-template #deductNotApplicable>
                                        N/A
                                    </ng-template>
                                </div>
                            </ng-container>
                            <!-- special case both coverage and term have the values -->
                            <ng-container
                                *ngIf="vehicleCoverage.coverageName === 'Other Than Collision Loss Settle'">
                                <ng-container *ngFor="let otherCollisionTerm of vehicleCoverage.coverageTerms">
                                    <ng-container *ngIf="otherCollisionTerm.termName === '$0 Glass Deductible'">
                                        <div class="row fs-14 w-100 no-margin-horizontal">
                                            <div class="col-md-6 col-sm-12 c-padding-l left-text">
                                                    {{ otherCollisionTerm.termName }}
                                            </div>
                                            <div class="col-md-3 c-width c-text c-text-align c-text-left">
                                                    <ng-container
                                                        *ngIf="otherCollisionTerm.termAmount === 'Yes'">
                                                        Included
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="otherCollisionTerm.termAmount === 'No'">
                                                        N/A
                                                    </ng-container>
                                                </div>
                                        </div>
                                    </ng-container>
                                        
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>